import { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import './Common.css';
import heroVideo from "../assets/adba_banner_video.mp4";
import aboutimage from '../assets/about.png'
import finals from "../assets/finals.png";
import training from "../assets/training.png";
import award from "../assets/award.png";
import state from "../assets/state.png";
import junior from "../assets/junior.png";
import westzone from "../assets/westzone.png";
import practice from "../assets/practice.png";
import prize from "../assets/prize.png";
import opening from "../assets/opening.png";
import juniorzone from "../assets/juniorzone.jpg";
import awards from "../assets/award.jpg";

/* ══════════════════════════════════════
   DATA
══════════════════════════════════════ */
// const MQ_ITEMS = ["Anand District","GBA Affiliated","BAI Member","Tournament Host","Excellence in Badminton","Fostering Talent","Community Sport","All Age Levels","Sportsmanship","Competitive Play"];

const GALLERY_IMGS = [
    { src: finals, title: "Tournament Finals 2024", sub: "District Championship", cat: "Tournament" },
    { src: training, title: "Training Session", sub: "Morning Practice", cat: "Training" },
    { src: award, title: "Award Ceremony", sub: "State Level Awards", cat: "Awards" },
    { src: state, title: "State Championship", sub: "GBA 2024", cat: "State" },
    { src: junior, title: "Junior League", sub: "U15 Category", cat: "Junior" },
    { src: westzone, title: "West Zone 2024", sub: "Anand Hosted", cat: "West Zone" },
    { src: practice, title: "Club Practice", sub: "Weekly Sessions", cat: "Practice" },
    { src: prize, title: "Prize Distribution", sub: "Champions Night", cat: "Awards" },
    { src: opening, title: "Opening Ceremony", sub: "Annual Tournament", cat: "Events" },
];

const SLIDE_IMGS = [
    { src: "https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=1200&q=80", title: "National Championship 2024", sub: "3 Gold Medals · Anand District Players" },
    // { src: "https://images.unsplash.com/photo-1613918431703-aa50889e3be6?w=1200&q=80", title: "State Level Tournament", sub: "12 District Players Qualified to State" },
    { src: awards, title: "West Zone Championship", sub: "Hosted by ADBA · Anand · 2024" },
    { src: juniorzone, title: "Junior Excellence Award", sub: "Top 5 Rankings · GBA Tournament 2024" },
    { src: junior, title: "U17 State Champions", sub: "Gold & Silver · Both Category Finals" },
];

// const ABOUT_IMG = "https://images.unsplash.com/photo-1613918431703-aa50889e3be6?w=900&q=80";

// const GBA_T = [
//     { no: 1, date: "04–09 June", cat: "U 13 & 15", venue: "GNFC Sports Complex", dist: "Bharuch", badge: "cb-u13", hl: false },
//     { no: 2, date: "19–23 June", cat: "Women & Men", venue: "ONGC Sports Complex", dist: "Surat", badge: "cb-open", hl: false },
//     { no: 3, date: "03–07 July", cat: "U 17", venue: "Iffco Sports Complex, Kalol", dist: "Gandhinagar", badge: "cb-u17", hl: false },
//     { no: 4, date: "16–21 July", cat: "U 19, W & M", venue: "TBC", dist: "Rajkot", badge: "cb-u19", hl: false },
//     { no: 5, date: "31 Jul–04 Aug", cat: "U 13", venue: "Pandit Dindayal Sports Complex", dist: "Navsari", badge: "cb-u13", hl: false },
//     { no: 6, date: "03–06 Sep", cat: "West Zone", venue: "7 Sports Academy", dist: "Anand", badge: "cb-west", hl: true },
//     { no: 7, date: "25–28 Sep", cat: "U 13", venue: "Toral Memorial Hall, Palanpur", dist: "Banaskantha", badge: "cb-u13", hl: false },
//     { no: 8, date: "09–13 Oct", cat: "U 19", venue: "KDBA Sports Complex", dist: "Kutch", badge: "cb-u19", hl: false },
//     { no: 9, date: "20–24 Nov", cat: "Women & Men", venue: "TBC", dist: "Jamnagar", badge: "cb-open", hl: false },
// ];

const GBA_T = [
    // { no: 1, date: "25 Feb–01 Mar", cat: "Masters (Veteran)", venue: "ONEIROS, The Sports Club", dist: "Surat", badge: "cb-masters", hl: false },
    { no: 1, date: "01 to 05 June", cat: "Women & Men", venue: "Blackk & One Academy ", dist: "Vadodara", badge: "cb-open", hl: false },
    { no: 2, date: "05 to 07 June", cat: "U 11", venue: "Master Sports Academy", dist: "Bharuch", badge: "cb-u11", hl: false },
    { no: 3, date: "09 to 14 June", cat: "U 13 & 15", venue: "GNFC Sports Complex", dist: "Bharuch", badge: "cb-u13-15", hl: false },
    { no: 4, date: "11 to 14 June", cat: "U 19", venue: "SAG Sports Complex, Vyara", dist: "Tapi", badge: "cb-u19", hl: false },
    { no: 5, date: "23 to 28 June", cat: "Women & Men", venue: "Staff & Officer Club, Kribhco", dist: "Surat", badge: "cb-open", hl: false },
    { no: 6, date: "09 to 12 July", cat: "U 15", venue: "Unnati Badminton Academy", dist: "Surat", badge: "cb-u15", hl: false },
    { no: 7, date: "05 to 09 August", cat: "U 19", venue: "SAG Sports Complex", dist: "Anand", badge: "cb-u19", hl: false },
];
const DIST_T = [
    {
        no: 1,
        date: "18–21 June, 2026",
        cat: "U11, U13, U15, U17, U19, OPEN, MASTERS 35+, MASTERS 45+",
        venue: "H M Patel Badminton Hall in Vallabh Vidyanagar",
        dist: "Anand",
        badge: "cb-ranking",
        hl: true
    }
    // { no: 1, date: "15–17 Jan", cat: "U 13", venue: "ADBA Indoor Hall", dist: "Anand", badge: "cb-u13", hl: true },
    // { no: 2, date: "02–04 Feb", cat: "U 15", venue: "ADBA Indoor Hall", dist: "Anand", badge: "cb-u13", hl: true },
    // { no: 3, date: "22–24 Feb", cat: "U 17", venue: "ADBA Indoor Hall", dist: "Anand", badge: "cb-u17", hl: true },
    // { no: 4, date: "14–16 Mar", cat: "U 19", venue: "ADBA Indoor Hall", dist: "Anand", badge: "cb-u19", hl: true },
    // { no: 5, date: "04–06 Apr", cat: "Open", venue: "ADBA Indoor Hall", dist: "Anand", badge: "cb-open", hl: true },
    // { no: 6, date: "18–20 Apr", cat: "District Champ", venue: "ADBA Indoor Hall", dist: "Anand", badge: "cb-dist", hl: true },
];

const RANKERS_DATA = [
    // Men's Singles
    { rank: 1, name: "Aarav Sharma", category: "Men's Singles", points: 8200 },
    { rank: 2, name: "Kabir Mehta", category: "Men's Singles", points: 7950 },
    { rank: 3, name: "Rohan Patel", category: "Men's Singles", points: 7600 },
    { rank: 4, name: "Dev Shah", category: "Men's Singles", points: 7200 },
    { rank: 5, name: "Vivaan Joshi", category: "Men's Singles", points: 6850 },
    { rank: 6, name: "Sai Prasad", category: "Men's Singles", points: 6500 },
    { rank: 7, name: "Arjun Verma", category: "Men's Singles", points: 6200 },
    { rank: 8, name: "Karan Johar", category: "Men's Singles", points: 5900 },
    { rank: 9, name: "Dhruv Alpesh", category: "Men's Singles", points: 5750 },
    { rank: 10, name: "Yash Trivedi", category: "Men's Singles", points: 5400 },

    // Women's Singles
    { rank: 1, name: "Ananya Iyer", category: "Women's Singles", points: 8500 },
    { rank: 2, name: "Diya Sharda", category: "Women's Singles", points: 8100 },
    { rank: 3, name: "Riya Vadgama", category: "Women's Singles", points: 7800 },
    { rank: 4, name: "Isha Patel", category: "Women's Singles", points: 7300 },
    { rank: 5, name: "Meera Sodha", category: "Women's Singles", points: 7000 },
    { rank: 6, name: "Komal Rathod", category: "Women's Singles", points: 6600 },
    { rank: 7, name: "Sanya Gupta", category: "Women's Singles", points: 6300 },
    { rank: 8, name: "Pooja Patel", category: "Women's Singles", points: 6050 },
    { rank: 9, name: "Neha Shah", category: "Women's Singles", points: 5800 },
    { rank: 10, name: "Kriti Bhatt", category: "Women's Singles", points: 5500 },

    // Boys U19 Singles
    { rank: 1, name: "Harshil Dani", category: "Boys U19 Singles", points: 8900 },
    { rank: 2, name: "Jeet Patel", category: "Boys U19 Singles", points: 8400 },
    { rank: 3, name: "Sarthak Sen", category: "Boys U19 Singles", points: 7900 },
    { rank: 4, name: "Nimit Patel", category: "Boys U19 Singles", points: 7400 },
    { rank: 5, name: "Aman Shah", category: "Boys U19 Singles", points: 7100 },
    { rank: 6, name: "Smit Parmar", category: "Boys U19 Singles", points: 6750 },
    { rank: 7, name: "Preet Vaghela", category: "Boys U19 Singles", points: 6400 },
    { rank: 8, name: "Parth Soni", category: "Boys U19 Singles", points: 6100 },
    { rank: 9, name: "Manan Amin", category: "Boys U19 Singles", points: 5850 },
    { rank: 10, name: "Vraj Patel", category: "Boys U19 Singles", points: 5600 }
];
// const DIST_T = [
//     { no: 1, date: "18–21 June", cat: "U 11", venue: "TO BE DECLARED SOON", dist: "Anand", badge: "cb-u11", hl: true },
//     { no: 2, date: "18–21 June", cat: "U 13", venue: "TO BE DECLARED SOON", dist: "Anand", badge: "cb-u13", hl: true },
//     { no: 3, date: "18–21 June", cat: "U 15", venue: "TO BE DECLARED SOON", dist: "Anand", badge: "cb-u15", hl: true },
//     { no: 4, date: "18–21 June", cat: "U 17", venue: "TO BE DECLARED SOON", dist: "Anand", badge: "cb-u17", hl: true },
//     { no: 5, date: "18–21 June", cat: "U 19", venue: "TO BE DECLARED SOON", dist: "Anand", badge: "cb-u19", hl: true },
//     { no: 6, date: "18–21 June", cat: "OPEN", venue: "TO BE DECLARED SOON", dist: "Anand", badge: "cb-open", hl: true },
//     { no: 7, date: "18–21 June", cat: "MASTERS 35+", venue: "TO BE DECLARED SOON", dist: "Anand", badge: "cb-masters", hl: true },
//     { no: 8, date: "18–21 June", cat: "MASTERS 45+", venue: "TO BE DECLARED SOON", dist: "Anand", badge: "cb-masters", hl: true }
// ];
/* ══════════════════════════════════════
   CSS INJECT (once)
══════════════════════════════════════ */
let cssInjected = false;
const injectCSS = () => {
    if (cssInjected || typeof document === "undefined") return;
    const el = document.createElement("style");
    el.innerHTML = CSS;
    document.head.appendChild(el);
    cssInjected = true;
};

/* ══════════════════════════════════════
   HOOKS
══════════════════════════════════════ */
const useSmoothSY = () => {
    const [sy, setSy] = useState(0);
    const tgt = useRef(0); const cur = useRef(0); const raf = useRef(null);
    useEffect(() => {
        const fn = () => { tgt.current = window.scrollY; };
        window.addEventListener("scroll", fn, { passive: true });
        const loop = () => {
            cur.current += (tgt.current - cur.current) * .09;
            if (Math.abs(cur.current - tgt.current) < .3) cur.current = tgt.current;
            setSy(cur.current);
            raf.current = requestAnimationFrame(loop);
        };
        raf.current = requestAnimationFrame(loop);
        return () => { window.removeEventListener("scroll", fn); cancelAnimationFrame(raf.current); };
    }, []);
    return sy;
};

const useIO = (sel, thresh = 0.12) => {
    useEffect(() => {
        const els = document.querySelectorAll(sel);
        if (!els.length) return;
        const obs = new IntersectionObserver(entries => {
            entries.forEach(e => {
                if (e.isIntersecting) { e.target.classList.add("fired"); obs.unobserve(e.target); }
            });
        }, { threshold: thresh });
        els.forEach(el => { if (!el.classList.contains("fired")) obs.observe(el); });
        return () => obs.disconnect();
    });
};

/* ══════════════════════════════════════
   COUNTER
══════════════════════════════════════ */
const Counter = ({ to, sfx = "" }) => {
    const [v, setV] = useState(0);
    const ref = useRef(null); const fired = useRef(false);
    useEffect(() => {
        const obs = new IntersectionObserver(([e]) => {
            if (e.isIntersecting && !fired.current) {
                fired.current = true;
                const n = parseInt(to), dur = 1600, t0 = performance.now();
                const tick = (now) => {
                    const p = Math.min((now - t0) / dur, 1);
                    setV(Math.round((1 - Math.pow(1 - p, 3)) * n));
                    if (p < 1) requestAnimationFrame(tick);
                };
                requestAnimationFrame(tick);
            }
        }, { threshold: .5 });
        if (ref.current) obs.observe(ref.current);
        return () => obs.disconnect();
    }, [to]);
    return <span ref={ref}>{v}{sfx}</span>;
};

/* ══════════════════════════════════════
   SECTION 1 — HERO (VIDEO)
══════════════════════════════════════ */
const Hero = ({ sy }) => {
    const videoRef = useRef(null);
    const [muted, setMuted] = useState(true);
    const [vidErr, setVidErr] = useState(false);

    const rings = [
        { sz: 550, ox: "72%", oy: "50%", spd: .025, accent: false },
        { sz: 320, ox: "78%", oy: "35%", spd: .048, accent: true },
        { sz: 170, ox: "74%", oy: "62%", spd: .078, accent: false },
        { sz: 240, ox: "18%", oy: "28%", spd: .035, accent: true },
    ];

    const toggleMute = () => {
        if (videoRef.current) { videoRef.current.muted = !muted; setMuted(v => !v); }
    };

    return (
        <section className="hero" id="home">
            {/* VIDEO */}
            <div className="hero-video-wrap">
                <div className="hero-video-fallback" />
                {!vidErr && (
                    <video
                        ref={videoRef} autoPlay muted loop playsInline
                        onError={() => setVidErr(true)}
                        style={{ transform: `scale(1.06) translateY(${sy * .04}px)`, transition: "transform .04s linear" }}
                    >
                        <source src={heroVideo} type="video/mp4" />
                    </video>
                )}
                {vidErr && (
                    <div style={{ position: "absolute", inset: 0, background: "linear-gradient(150deg,#1A0000 0%,#7B0000 45%,#CC0000 100%)", transform: `translateY(${sy * .12}px)`, transition: "transform .04s linear" }}>
                        <div className="hero-fallback-grid" />
                        {[[14, 7, null, 52, .055, 22], [70, null, 8, 40, .04, -16], [35, null, 5, 28, .07, 14], [80, 15, null, 22, .045, -38]].map(([t, l, r, sz, spd, rot], i) => (
                            <div key={i} style={{
                                position: "absolute", pointerEvents: "none", opacity: .14,
                                top: `${t}%`, left: l ? `${l}%` : undefined, right: r ? `${r}%` : undefined,
                                transform: `translateY(${sy * spd}px) rotate(${rot}deg)`, transition: "transform .04s linear"
                            }}>
                                <svg width={sz} height={sz * 1.2} viewBox="0 0 36 44" fill="none">
                                    <circle cx="18" cy="34" r="8" fill="rgba(255,100,100,.85)" />
                                    {[0, 45, 90, 135, 180, 225, 270, 315].map((d, j) => (
                                        <line key={j} x1="18" y1="34"
                                            x2={18 + Math.cos((d - 90) * Math.PI / 180) * 18}
                                            y2={34 + Math.sin((d - 90) * Math.PI / 180) * 18}
                                            stroke="rgba(255,255,255,.6)" strokeWidth="1.2" />
                                    ))}
                                    <ellipse cx="18" cy="14" rx="12" ry="16" fill="none" stroke="rgba(255,255,255,.45)" strokeWidth="1.5" />
                                </svg>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* OVERLAYS */}
            <div className="hero-vid-overlay" />
            <div className="hero-vid-color" />
            <div className="hero-grid" />

            {/* RINGS */}
            {rings.map((r, i) => (
                <div key={i} className="hero-ring" style={{
                    width: r.sz, height: r.sz, left: r.ox, top: r.oy,
                    transform: `translate(-50%,-50%) rotate(${sy * r.spd}deg)`,
                    transition: "transform .04s linear",
                    border: `1px solid ${r.accent ? "rgba(230,51,51,.2)" : "rgba(255,255,255,.06)"}`,
                }} />
            ))}

            {/* CONTENT */}
            <div className="hero-content" style={{ transform: `translateY(${sy * -.07}px)`, transition: "transform .04s linear" }}>
                <div className="hero-eyebrow">
                    <span className="h-pulse" />
                    Anand District · Gujarat · India
                </div>
                <h1 className="hero-title">
                    <span className="hero-hl"><span>Anand District</span></span>
                    <span className="hero-hl"><span>BADMINTON</span></span>
                    <span className="hero-hl"><span>ASSOCIATION</span></span>
                </h1>
                <p className="hero-sub">
                    Dedicated to promoting excellence in badminton and fostering
                    community through sports. Affiliated to GBA &amp; BAI.
                </p>
                <div className="hero-btns">
                    {/* <button className="btn-w"><span>Explore Events →</span></button> */}
                    <a href="#events" className="btn-w"><span>Explore Events →</span></a>
                    <Link to="/about" className="btn-ow">About ADBA</Link>
                </div>
            </div>


            <div className="hero-scroll"><div className="scroll-bar" />Scroll</div>
        </section>
    );
};

/* ══════════════════════════════════════
   SECTION 2 — MARQUEE
══════════════════════════════════════ */
// const Marquee = () => {
//   const dbl = [...MQ_ITEMS, ...MQ_ITEMS];
//   return (
//     <div className="mq">
//       {[false, true].map((r, i) => (
//         <div key={i} className="mq-row">
//           <div className={`mq-track ${r?"rev":""}`}>
//             {dbl.map((t, j) => (
//               <div key={j} className="mq-item">
//                 <span className="mq-dot"/>{t}
//               </div>
//             ))}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

/* ══════════════════════════════════════
   SECTION 3 — STATS
══════════════════════════════════════ */
const Stats = () => (
    <div className="hp-stats">
        {[
            { n: "12", sfx: "+", l: "Years of Service" },
            { n: "250", sfx: "+", l: "Players Registered" },
            { n: "10", sfx: "+", l: "Tournaments Hosted" },
            { n: "15", sfx: "+", l: "State Champions" },
        ].map((s, i) => (
            <div key={i} className="stat-cell">
                <span className="stat-num"><Counter to={s.n} /><span className="stat-sfx">{s.sfx}</span></span>
                <span className="stat-lbl">{s.l}</span>
            </div>
        ))}
    </div>
);

/* ══════════════════════════════════════
   SECTION 4 — ABOUT
══════════════════════════════════════ */
const About = ({ sy }) => {
    const ref = useRef(null);
    const [top, setTop] = useState(0);
    useEffect(() => {
        const u = () => { if (ref.current) setTop(ref.current.offsetTop); };
        u(); window.addEventListener("resize", u);
        return () => window.removeEventListener("resize", u);
    }, []);
    const local = Math.max(0, sy - top + window.innerHeight * .5);

    return (
        <section className="hp-sec" id="about" ref={ref}>
            <div className="about-grid">

                {/* Image */}
                <div className="about-img-wrap hp-fup">
                    <div className="about-top-badge">GBA &amp; BAI Affiliated</div>

                    <div className="about-img-card">
                        <img
                            src={aboutimage}
                            alt="Badminton players in action"
                            style={{
                                transform: `translateY(${-local * .04}px)`,
                                transition: "transform .04s linear"
                            }}
                        />
                        <div className="about-img-veil" />
                    </div>

                    <div className="about-float-card">
                        <div className="afc-icon">🏆</div>
                        <div>
                            <span className="afc-val">15+</span>
                            <span className="afc-sub">State Champions Produced</span>
                        </div>
                    </div>
                </div>

                {/* Text */}
                <div>
                    <div className="hp-stag hp-fup"><span className="hp-stag-bar" />About Us</div>
                    <h2 className="hp-rtitle hp-fup">
                        <span className="rl"><span className="ri">PROMOTING</span></span>
                        <span className="rl"><span className="ri accent">EXCELLENCE.</span></span>
                    </h2>
                    <p className="about-body hp-fup d1" style={{ marginTop: 20 }}>
                        Welcome to the Anand District Badminton Association, dedicated to promoting
                        and advancing the sport of badminton in our community. Founded with a passion
                        for excellence and inclusivity, we aim to foster talent, organize competitive
                        events, and encourage sportsmanship among players of all ages and skill levels.
                    </p>
                    <p className="about-body hp-fup d2">
                        Through our commitment to professionalism and fair play, we strive to uphold
                        the highest standards in badminton while nurturing a vibrant sporting culture
                        across Anand District.
                    </p>
                    <div className="about-feats hp-fup d3">
                        {[
                            { icon: "🏸", name: "All Age Groups", sub: "U13 · U15 · U17 · U19 · Open" },
                            { icon: "🏆", name: "State Level Prep", sub: "GBA & BAI tournaments" },
                            { icon: "🎯", name: "Expert Coaching", sub: "Qualified BWF coaches" },
                            { icon: "🤝", name: "Community Sport", sub: "Inclusive & fair play" },
                        ].map(f => (
                            <div key={f.name} className="af-item">
                                <span className="af-icon">{f.icon}</span>
                                <div><div className="af-name">{f.name}</div><div className="af-sub">{f.sub}</div></div>
                            </div>
                        ))}
                    </div>
                    <Link to="/about" className="btn-red hp-fup d4"><span>Know More →</span></Link>
                </div>
            </div>
        </section>
    );
};

/* ══════════════════════════════════════
   SECTION 5 — IMAGE GALLERY
══════════════════════════════════════ */
const ImageGallery = () => {
    const [lb, setLb] = useState(null);

    const closeLb = () => setLb(null);
    const prevImg = (e) => { e.stopPropagation(); setLb(v => (v - 1 + GALLERY_IMGS.length) % GALLERY_IMGS.length); };
    const nextImg = (e) => { e.stopPropagation(); setLb(v => (v + 1) % GALLERY_IMGS.length); };

    useEffect(() => {
        const fn = e => {
            if (e.key === "Escape") closeLb();
            if (e.key === "ArrowLeft") setLb(v => v !== null ? (v - 1 + GALLERY_IMGS.length) % GALLERY_IMGS.length : v);
            if (e.key === "ArrowRight") setLb(v => v !== null ? (v + 1) % GALLERY_IMGS.length : v);
        };
        window.addEventListener("keydown", fn);
        return () => window.removeEventListener("keydown", fn);
    }, []);

    return (
        <section className="hp-sec hp-sec-alt" id="gallery">
            {/* Intro */}
            <div className="gal-intro">
                <div>
                    <div className="hp-stag hp-fup"><span className="hp-stag-bar" />Photo Gallery</div>
                    <h2 className="hp-rtitle hp-fup">
                        <span className="rl"><span className="ri">MOMENTS</span></span>
                        <span className="rl"><span className="ri accent">CAPTURED.</span></span>
                    </h2>
                    <p className="hp-fup d1" style={{ fontSize: 15, color: "var(--sub)", maxWidth: 380, lineHeight: 1.74, fontWeight: 300, marginTop: 12 }}>
                        Relive the thrilling action, proud victories, and community spirit from ADBA events and tournaments.
                    </p>
                </div>
                <div className="hp-fup d2" style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8 }}>
                    <div className="gal-big-num">{GALLERY_IMGS.length}<span className="gal-big-sfx">+</span></div>
                    <div className="gal-big-lbl">Photos</div>
                </div>
            </div>

            {/* Grid */}
            <div className="img-grid">
                {GALLERY_IMGS.map((img, i) => (
                    <div key={i} className="ig hp-fup" style={{ transitionDelay: `${i * .05}s` }} onClick={() => setLb(i)}>
                        <img src={img.src} alt={img.title} loading="lazy" />
                        <span className="ig-cat">{img.cat}</span>
                        <div className="ig-overlay">
                            <div className="ig-overlay-icon">⊕</div>
                            <div className="ig-title">{img.title}</div>
                            <div className="ig-sub">{img.sub}</div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="gal-footer hp-fup d3">
                <span className="gal-count">Showing <strong>{GALLERY_IMGS.length}</strong> of our best moments</span>
                <Link to="/gallery" className="btn-red"><span>View Full Gallery →</span></Link>
            </div>

            {/* LIGHTBOX */}
            {lb !== null && (
                <div className="lb" onClick={closeLb}>
                    <button className="lb-close" onClick={closeLb}>✕</button>
                    <div className="lb-wrap" onClick={e => e.stopPropagation()}>
                        <img
                            src={GALLERY_IMGS[lb].src.replace("w=700", "w=1200").replace("w=600", "w=1000")}
                            alt={GALLERY_IMGS[lb].title}
                        />
                        <button className="lb-prev" onClick={prevImg}>‹</button>
                        <button className="lb-next" onClick={nextImg}>›</button>
                        <div className="lb-caption">{GALLERY_IMGS[lb].title} · {GALLERY_IMGS[lb].sub}</div>
                    </div>
                </div>
            )}
        </section>
    );
};

/* ══════════════════════════════════════
   SECTION 6 — EVENTS TABLE
══════════════════════════════════════ */
const Events = () => {
    const [sel, setSel] = useState("GBA");
    const list = sel === "GBA" ? GBA_T : DIST_T;

    return (
        <section className="hp-sec" id="events">
            <div style={{ maxWidth: 700, marginBottom: 48 }}>
                <div className="hp-stag hp-fup"><span className="hp-stag-bar" />Upcoming Tournaments</div>
                <h2 className="hp-rtitle hp-fup">
                    <span className="rl"><span className="ri">TOURNAMENT</span></span>
                    <span className="rl"><span className="ri accent">CALENDAR.</span></span>
                </h2>
                <p className="hp-fup d1" style={{ fontSize: 16, lineHeight: 1.78, color: "var(--sub)", fontWeight: 300, marginTop: 14 }}>
                    Official 2026 tournament calendar affiliated to Gujarat Badminton Association and BAI.
                </p>
            </div>

            {/* Tab switcher */}
            <div className="ev-controls hp-fup d2">
                <span className="ev-label">Filter by Body:</span>
                <div className="ev-tabs">
                    <button
                        className={`ev-tab ${sel === "GBA" ? "active" : ""}`}
                        onClick={() => setSel("GBA")}
                    >
                        🏅 GBA Tournaments
                    </button>
                    <button
                        className={`ev-tab ${sel === "District" ? "active" : ""}`}
                        onClick={() => setSel("District")}
                    >
                        📍 District Level
                    </button>
                </div>
                <span className="ev-count">{list.length} Events</span>
            </div>

            {/* Table — unchanged */}
            <div className="ev-table-wrap hp-fup d3">
                <table>
                    <thead>
                        <tr>
                            <th>Sr.</th><th>Date</th><th>Category</th><th>Venue</th><th>District</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map(t => (
                            <tr key={t.no} className={t.hl ? "t-hl" : ""}>
                                <td className="t-sr">{String(t.no).padStart(2, "0")}</td>
                                <td className="t-date">{t.date}</td>
                                {/* <td><span className={`cat-b ${t.badge}`}>{t.cat}</span></td> */}
                                <td>
                                    <div className="category-badges-wrapper">
                                        {t.cat && t.cat.split(",").map((singleCat, index) => (
                                            <span key={index} className={`cat-b ${t.badge}`}>
                                                {singleCat.trim()}
                                            </span>
                                        ))}
                                    </div>
                                </td>
                                <td>{t.venue}</td>
                                <td>
                                    {t.dist === "Anand"
                                        ? <><span className="t-star">★</span>{t.dist}</>
                                        : t.dist}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
};

/* ══════════════════════════════════════
   SECTION 6.5 — STANDINGS TABLE
   ══════════════════════════════════════ */
const Standings = () => {
    const [selectedCategory, setSelectedCategory] = useState("Men's Singles");
    const categories = Array.from(new Set(RANKERS_DATA.map(r => r.category)));
    const filteredRankers = RANKERS_DATA.filter(r => r.category === selectedCategory);

    return (
        <section className="hp-sec hp-sec-alt" id="standings">
            <div style={{ maxWidth: 700, marginBottom: 48 }}>
                <div className="hp-stag hp-fup"><span className="hp-stag-bar" />Official Standings</div>
                <h2 className="hp-rtitle hp-fup">
                    <span className="rl"><span className="ri">🏆 ANAND DISTRICT</span></span>
                    <span className="rl"><span className="ri accent">TOP 10 STANDINGS.</span></span>
                </h2>
                <p className="hp-fup d1" style={{ fontSize: 16, lineHeight: 1.78, color: "var(--sub)", fontWeight: 300, marginTop: 14 }}>
                    Official current district ranking stands and points. Filter categories using the select box.
                </p>
            </div>

            {/* Dropdown Category Filter styled premium */}
            <div className="hp-fup d2" style={{ display: "flex", justifyContent: "flex-start", gap: "12px", alignItems: "center", marginBottom: "20px" }}>
                <label className="reg-label" style={{ fontSize: "11px", letterSpacing: "1px", color: "var(--light)", margin: 0, textTransform: "uppercase", fontWeight: "700" }}>Select Category:</label>
                <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                    <select
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        className="reg-select"
                        style={{
                            padding: "10px 36px 10px 16px",
                            borderRadius: "8px",
                            border: "1.5px solid var(--border)",
                            background: "#fff",
                            color: "var(--text)",
                            fontFamily: "var(--fu)",
                            fontWeight: "600",
                            fontSize: "13.5px",
                            outline: "none",
                            cursor: "pointer",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.03)"
                        }}
                    >
                        {categories.map(cat => (
                            <option key={cat} value={cat}>{cat}</option>
                        ))}
                    </select>
                    <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="var(--sub)"
                        strokeWidth="3"
                        strokeLinecap="round"
                        style={{ position: "absolute", right: "14px", pointerEvents: "none" }}
                    >
                        <polyline points="6 9 12 15 18 9" />
                    </svg>
                </div>
            </div>

            {/* Scrollable Rankers Table */}
            <div className="ev-table-wrap hp-fup d3" style={{ maxHeight: "400px", overflowY: "auto", border: "1.5px solid var(--border)", borderRadius: "16px", boxShadow: "0 8px 30px rgba(0,0,0,0.02)" }}>
                <table style={{ minWidth: "500px" }}>
                    <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
                        <tr style={{ background: "var(--rg)" }}>
                            <th style={{ width: "85px" }}>Rank</th>
                            <th>Player Name</th>
                            <th>Category</th>
                            <th style={{ width: "115px", textAlign: "right" }}>Points</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredRankers.map(r => (
                            <tr key={r.rank} className={r.rank <= 3 ? "t-hl" : ""} style={r.rank <= 3 ? { background: "rgba(204, 0, 0, 0.02)" } : {}}>
                                <td className="t-sr" style={{ fontFamily: "var(--fu)", fontWeight: "800", fontSize: "12.5px" }}>
                                    {r.rank === 1 ? "🥇 01" : r.rank === 2 ? "🥈 02" : r.rank === 3 ? "🥉 03" : String(r.rank).padStart(2, "0")}
                                </td>
                                <td style={{ fontWeight: r.rank <= 3 ? "700" : "500", fontSize: "14px" }}>{r.name}</td>
                                <td>
                                    <span className="cat-b cb-ranking" style={{ fontSize: "9px", padding: "3px 8px", background: "rgba(204, 0, 0, 0.06)", color: "var(--r3)", borderRadius: "100px", fontWeight: "700" }}>{r.category}</span>
                                </td>
                                <td style={{ textAlign: "right", fontWeight: "800", color: "var(--r3)", fontFamily: "var(--fd)", fontSize: "15px", letterSpacing: "0.5px" }}>
                                    {r.points.toLocaleString("en-IN")}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
};

/* ══════════════════════════════════════
   SECTION 7 — ACHIEVEMENTS SLIDER
══════════════════════════════════════ */
const Achievements = () => {
    const [idx, setIdx] = useState(0);
    const [auto, setAuto] = useState(true);
    const timer = useRef(null);

    const next = useCallback(() => setIdx(i => (i + 1) % SLIDE_IMGS.length), []);
    const prev = useCallback(() => setIdx(i => (i - 1 + SLIDE_IMGS.length) % SLIDE_IMGS.length), []);
    const go = n => { setIdx(n); setAuto(false); setTimeout(() => setAuto(true), 5000); };

    useEffect(() => {
        if (!auto) return;
        timer.current = setInterval(next, 4800);
        return () => clearInterval(timer.current);
    }, [next, auto]);

    return (
        <section className="hp-sec hp-sec-dark" id="achievements">
            <div style={{ maxWidth: 580, marginBottom: 52 }}>
                <div className="hp-stag inv hp-fup"><span className="hp-stag-bar" />Achievements</div>
                <h2 className="hp-rtitle inv hp-fup">
                    <span className="rl"><span className="ri">REMARKABLE</span></span>
                    <span className="rl"><span className="ri" style={{ WebkitTextStroke: "2px rgba(255,100,100,.65)", color: "transparent" }}>MILESTONES.</span></span>
                </h2>
                <p className="hp-fup d1" style={{ fontSize: 16, lineHeight: 1.78, color: "rgba(255,255,255,.4)", fontWeight: 300, marginTop: 14 }}>
                    Celebrating the remarkable milestones and accolades of our athletes and association.
                </p>
            </div>

            <div className="slider-outer hp-fup d2">
                <div className="slider-track" style={{ transform: `translateX(${-idx * 100}%)` }}>
                    {SLIDE_IMGS.map((s, i) => (
                        <div key={i} className="slide">
                            <div className="slide-img">
                                <img src={s.src} alt={s.title} style={{ filter: "brightness(.6) saturate(.8)" }} />
                            </div>
                            <div className="slide-veil" />
                            <div className="slide-cap">
                                <span className="sc-num">{i + 1} / {SLIDE_IMGS.length}</span>
                                <div className="sc-title">{s.title}</div>
                                <div className="sc-sub">{s.sub}</div>
                            </div>
                        </div>
                    ))}
                </div>
                <button className="sl-btn sl-prev" onClick={() => { prev(); setAuto(false); }}>‹</button>
                <button className="sl-btn sl-next" onClick={() => { next(); setAuto(false); }}>›</button>
                <div className="sl-dots">
                    {SLIDE_IMGS.map((_, i) => (
                        <button key={i} className={`sl-dot ${i === idx ? "on" : ""}`} onClick={() => go(i)} />
                    ))}
                </div>
            </div>
        </section>
    );
};

/* ══════════════════════════════════════
   SECTION 8 — CTA / CONTACT
══════════════════════════════════════ */
const CTA = () => {
    const isRegistered = !!sessionStorage.getItem("token");

    return (
        <section className="hp-cta" id="contact">
            <div className="cta-wm">ADBA</div>

            <div className="cta-in">
                <div className="hp-stag hp-fup" style={{ justifyContent: "center" }}>
                    <span className="hp-stag-bar" />Join the Association
                </div>

                <h2 className="cta-title hp-fup">
                    <span className="cta-solid">JOIN THE</span>
                    <span className="cta-outline">GAME.</span>
                </h2>

                <div className="cta-sep hp-fup d1" />

                <p className="cta-sub hp-fup d1">
                    Be part of the Anand District Badminton Association. Whether you're a
                    beginner or an elite player — there's a place for you here.
                </p>

                <div className="cta-btns hp-fup d2">
                    {!isRegistered && (
                        <Link to="/register" className="btn-cta-red"><span>Register Now →</span></Link>
                    )}
                    <Link to="/contact" className="btn-cta-outline">Contact Us</Link>
                </div>

                <div className="cta-pills hp-fup d3">
                    {[
                        { n: "250", sfx: "+", l: "Players Registered" },
                        { n: "12", sfx: "+", l: "Years of Service" },
                        { n: "15", sfx: "+", l: "State Champions" },
                        { n: "10", sfx: "+", l: "Tournaments Hosted" },
                    ].map((p, i) => (
                        <div key={i} className="cta-pill">
                            <span className="cta-pill-num">{p.n}<span>{p.sfx}</span></span>
                            <span className="cta-pill-lbl">{p.l}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

/* ══════════════════════════════════════
   HOME PAGE — default export
══════════════════════════════════════ */
const HomePage = () => {
    injectCSS();
    const sy = useSmoothSY();
    useIO(".hp-rtitle", .18);
    useIO(".hp-fup", .1);

    return (
        <>
            <Hero sy={sy} />
            {/* <Marquee /> */}
            <Stats />
            <About sy={sy} />
            <ImageGallery />
            <Events />
            {/* <Standings /> */}
            <Achievements />
            <CTA />
        </>
    );
};

export default HomePage;